"use strict";

var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  Object.defineProperty(o, k2, {
    enumerable: true,
    get: function get() {
      return m[k];
    }
  });
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});

var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  }

  __setModuleDefault(result, mod);

  return result;
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useSingleStateValidator = void 0;

var React = __importStar(require("react"));

function useSingleStateValidator(state, validator, initialState) {
  if (initialState === void 0) {
    initialState = [undefined];
  }

  var innerValidator = React.useRef(validator);
  var innerState = React.useRef(state);
  innerValidator.current = validator;
  innerState.current = state;

  var _a = React.useState(initialState),
      validity = _a[0],
      setValidity = _a[1];

  var validate = React.useCallback(function () {
    if (innerValidator.current.length >= 2) {
      innerValidator.current(innerState.current, setValidity);
    } else {
      setValidity(innerValidator.current(innerState.current));
    }
  }, [setValidity]);
  React.useEffect(function () {
    validate();
  }, [state]);
  return [validity, validate];
}

exports.useSingleStateValidator = useSingleStateValidator;